import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, LL_H_C, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import './Editor_DemoPatient.scss';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { ViewKey_Edit, ViewKey_View } from '../../../../../consts.js';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { Editor_JsonToObject } from '@nu-art/json-to-object-renderer/Editor_JsonToObject';
import { Dialog_Confirmation, ICONS } from '@app/styles';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
export class Editor_DemoPatient extends TS_EditableItemComponent {
    //######################### Logic #########################
    getPatientHeader = () => {
        const editableLabel = this.state.editable?.get('label');
        return editableLabel && editableLabel.trim() !== '' ? editableLabel : 'Patient ' + (this.props.index + 1);
    };
    onDeletePatient = () => {
        return Dialog_Confirmation.show({
            header: 'Are you sure?',
            content: () => _jsxs(_Fragment, { children: [_jsx("div", { children: "You're about to delete a patient" }), _jsx("div", { children: this.getPatientHeader() })] }),
            buttons: [
                {
                    label: 'Yes, Delete',
                    isAsync: true,
                    action: async () => this.props.onDelete()
                },
                {
                    label: 'Don\'t Delete',
                    isPreferred: true,
                    action: () => {
                    }
                }
            ]
        });
    };
    //######################### Render #########################
    render() {
        return _jsxs(Grid, { children: [this.renderHeader(), this.renderDemoPatients()] });
    }
    renderHeader = () => {
        const mode = this.props.mode;
        const isFreeTextMode = this.state.isFreeTextMode;
        const ACTIONS = mode === 'edit' ? _jsxs(_Fragment, { children: [_jsx(ICONS.bin.component, { className: 'demo-patient__header__action-icon', onClick: this.onDeletePatient }), _jsx(ICONS.edit.component, { onClick: () => this.setState({ isFreeTextMode: !isFreeTextMode }) })] }) : undefined;
        return _jsxs(_Fragment, { children: [_jsxs(LL_H_C, { className: 'demo-patient__header', children: [_jsx(ICONS.advisorPatient.component, { className: 'demo-patient__header__patient-icon' }), _jsx(TS_PropRenderer.Flat, { className: 'demo-patient__header__title', label: this.getPatientHeader() }), ACTIONS] }), _jsx("div", {})] });
    };
    renderPatientViewMode = () => {
        const { patientProps } = this.props;
        const { editable } = this.state;
        return _jsx(_Fragment, { children: patientProps.map((prop, index) => {
                const value = editable?.get(prop.name);
                return _jsx(TS_PropRenderer.Flat, { label: prop.label, children: value ?? _jsx("div", {}) }, index);
            }) });
    };
    renderPatientEditMode = () => {
        const { patientProps, validator } = this.props;
        const { editable, isFreeTextMode } = this.state;
        return _jsxs(_Fragment, { children: [_jsx(Editor_JsonToObject, { editable: editable, isFreeTextMode: !!isFreeTextMode, validator: validator, renderer: (editable) => {
                        return patientProps.map((prop, index) => _jsx(TS_PropRenderer.Flat, { label: prop.label, className: 'demo-patient__label', children: _jsx(DefaultEditor_InputText, { editable: editable, prop: prop.name }, index) }, index));
                    } }, editable.item.key), !!isFreeTextMode && _jsx("div", {}), _jsx(_Fragment, {})] });
    };
    renderDemoPatients = () => {
        const { mode, index } = this.props;
        return _jsx(Component_SwitchView, { mode: mode, modes: [
                {
                    key: ViewKey_View,
                    renderer: () => this.renderPatientViewMode()
                },
                {
                    key: ViewKey_Edit,
                    renderer: () => this.renderPatientEditMode()
                }
            ] }, index);
    };
}
//# sourceMappingURL=Editor_DemoPatient.js.map